import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="py-16 md:py-24 px-4 bg-brand-cream" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal mb-4" data-id="element-116">
            El problema no eres tú.
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-117">
            Es que la universidad te enseñó la teoría. Nadie te dio el sistema
            para la práctica real.
          </p>
          <p className="text-2xl font-bold text-brand-teal mt-8" data-id="element-118">
            Eso es exactamente lo que construimos.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center md:text-left" data-id="element-119">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-charcoal mb-6 text-center" data-id="element-120">
            Qué es el MEGA PACK KINESIOLOGÍA
          </h3>
          <div className="space-y-4 text-lg text-gray-700" data-id="element-121">
            <p data-id="element-122">No es un curso con videos que nunca terminas de ver.</p>
            <p data-id="element-123">No es un manual académico lleno de teoría que ya sabes.</p>
            <p className="font-semibold text-brand-teal" data-id="element-124">
              Es el sistema clínico completo que necesitas para llegar a cada
              sesión sabiendo exactamente qué evaluar, qué técnica aplicar, cómo
              progresar el tratamiento y cómo documentarlo.
            </p>
            <p data-id="element-125">Desde el primer paciente del lunes hasta el alta.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}